import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import LoadingUI from '../../tools/Loading';

// components
import Signup from '../../components/Auth/Signup';
// models
import User from '../../models/User';
// stores
import UserStore from '../../stores/UserStore';
// css
import './Auth.css';

const SignupPage = observer(
class SignupPage extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: "" };
  }

  render() {
    const {
      errorMessage,
    } = this.state;

    return (
      <div className="AuthPage-container">
        <div className="AuthPage-control">
          <Signup errorMessage={errorMessage} onSubmit={this.signupOnSubmit} />
        </div>
        <div className="AuthPage-switch-link">
          <Link to="/auth/login">I alreaday have an account</Link>
        </div>
      </div>
    );
  }

  signupOnSubmit = (userData) => {
    // block ui
    LoadingUI.show();
    // clear error message
    this.setState({ errorMessage: "" });
    // prep data
    let user = new User({
      name: userData.email.substr(0, userData.email.indexOf("@")),
      email: userData.email,
      phone: userData.phone,
    });
    // set
    UserStore
    .create(user, userData.password)
    .catch(e => {
      LoadingUI.hide();
      this.setState({ errorMessage: e.message });
    });
  }
});

export default SignupPage;


// WEBPACK FOOTER //
// ./src/pages/Auth/SignupPage.js